<div class="tagMemberDs__cont tagMemberDs__cont--{{tagStyle}}">
  <div class="tagMemberDs__tag tagMemberDs__tag--{{tagStyle}} tagMemberDs__tag--{{type}} tagMemberDs__tag--{{size}} tagMemberDs__tag--{{taggedStyle}}">
    <ng-container *ngIf="showIcon">
      <div class="tagMemberDs__icon tagMemberDs__icon--{{tagStyle}}">
        <app-ds-icon
          [icon]="icon"
          [size]="iconSize"
          [color]="iconFillColor">
        </app-ds-icon>
      </div>
    </ng-container>
    <div class="tagMemberDs__label">
      <app-ds-typography
        [text]="label"
        [size]="fontSize"
        [fontFamily]="labelFontFamily"
        [color]="labelColor">
      </app-ds-typography>
    </div>
  </div>
  <ng-container *ngIf="showStrikethrough">
    <div class="tagMemberDs__strikethrough tagMemberDs__strikethrough--{{tagStyle}}">
      <app-ds-typography
        [text]="strikethrough?.Value"
        [size]="fontSize"
        [color]="strikethroughColor"
        [textDecoration]="strikethroughDecoration">
      </app-ds-typography>
    </div>
  </ng-container>
</div>